import { render } from "./Sphere.vue?vue&type=template&id=0825f756"
import script from "./Sphere.vue?vue&type=script&lang=js"
export * from "./Sphere.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__